import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { map, filter } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { User } from '../../models/user';
import { ClientDetails } from '../../../clients/models/client-details';
import { ClientParent } from '../../../client-parents/models/client-parent';
import { UserLimiter } from '../../models/user-limiter';
import * as userActions from '../../actions/users';
import * as clientActions from '@clients/actions/client-details';
import * as clientParentActions from '@client-parents/actions/client-parents';
import { UserFilters } from '@users/models/user-filters';
import * as userSelectors from '../../selectors/users';
import { Limiter } from '../../../common/enums/limiter';
import { ProductService } from '../../../common/services/product.service';
import { MojoWellKnownNames } from '../../../common/constants/mojo-well-known-names';

@Component({
    selector: 'mojo-users-page',
    templateUrl: './users-page.component.html',
    styleUrls: ['./users-page.component.scss'],
})
export class UsersPageComponent implements OnInit, OnDestroy {
    title$: Observable<string>;
    isAlive: boolean = true;
    users$: Observable<User[]>;
    clients$: Observable<ClientDetails[]>;
    clientParents$: Observable<ClientParent[]>;
    loading$: Observable<boolean>;
    error$: Observable<string>;
    limitedByOptions$: Observable<UserLimiter[]>;

    constructor(
        route: ActivatedRoute,
        private readonly store: Store<any>,
        productService: ProductService) {
      this.store.dispatch(new userActions.Load());
      this.store.dispatch(new clientActions.Load());
      this.store.dispatch(new clientParentActions.Load());

        route.queryParams.subscribe(params => {
            const filter: UserFilters = params['filter'];
            this.store.dispatch(new userActions.SetUsersFilter(filter || 'All'));
        });

        const currentFilter = this.store.pipe(select(userSelectors.selectCurrentFilter));
        const currentTitle = productService.currentProductTitle('Manage My Users', MojoWellKnownNames.Products.Mci);

      this.title$ = combineLatest(currentFilter, currentTitle).pipe(map(([filter, title]) => `${title} - ${filter}`));

      this.users$ = this.store.pipe(select(userSelectors.getAllUsersWithClientAndParentObjects),
        filter(x => x != undefined),
        map((users: User[]) => {
          users.map((user: User) => {
            user.limitedByString = this.getLimitedByString(user);
            return user;
          });
          return users;
        }));

        this.error$ = this.store.pipe(select((state) => state.users.error));
        this.loading$ = this.store.pipe(select((state) => state.users.loading));
        this.clients$ = this.store.pipe(select((state) => state.clientDetails.clients));
        this.clientParents$ = this.store.pipe(select((state) => state.clientParents.clientParents));
        this.limitedByOptions$ = this.store.pipe(select((state) => state.users.limitedByOptions));


    }

    getLimitedByString(user: User) {
        if (user.limitedBy) {
            if (user.limitedBy.limiter === Limiter.ClientRef && user.selectedClient) {
                return user.selectedClient.Ref + ' - ' + user.selectedClient.Name + ' (' + user.limitedBy.name + ')';
            } else if (user.limitedBy.limiter === Limiter.ClientParentRef && user.selectedClientParent) {
                return user.selectedClientParent.Id + ' - ' + user.selectedClientParent.Name + ' (' + user.limitedBy.name + ')';
            } else {
                return 'None';
            }
        } else {
            return 'None';
        }
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.isAlive = false;
    }
}
